<template>
    <ul class="categoriesPickerWrapper">
        <li v-for="category in categories" v-if="category.id" :key="category.id" :class="activate === hauteur || hauteur === 1 ? 'active' : ''">
            <span class="block full pointer">
                <div
                    @click="
                        $emit('updateQuery', { name: 'Catalog', query: getLinkParams({ category: category.id }) });
                        changeg(category.id);
                    "
                    :key="category.id"
                    :class="['sectionType', 'pointer', category.subCategories.length > 0 ? 'haveChildren' : '']"
                >
                    {{ category.terms.name[$t("trad")] }}
                </div>
            </span>
            <category-picker
                v-if="category.subCategories.length"
                :categories="category.subCategories"
                :isActive="category.id === selectCategoryId ? hauteur + 1 : 0"
                :getLinkParams="getLinkParams"
                :getRouteParams="getRouteParams"
                :hauteur="hauteur + 1"
                @updateQuery="$emit('updateQuery', $event);"
            ></category-picker>
        </li>
    </ul>
</template>

<script>
export default {
    name: "category-picker",
    props: ["categories", "getLinkParams", "isActive", "hauteur", "getRouteParams"],
    data: () => ({
        selectCategoryId: null,
        activate: 0
    }),
    watch: {
        isActive: function(newVal, oldVal) {
            this.activate = newVal;
        }
    },
    methods: {
        changeg: function(categoryId) {
            this.selectCategoryId = this.selectCategoryId !== categoryId ? categoryId : null;
        }
    },
    created() {
        //this.getLinkParams("category").category);
    }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/themes.scss";

.categoriesPickerWrapper {
    li {
        span {
            a {
                text-decoration: none;
            }
            div {
                list-style: none;
                padding: 5px;
                margin: 0;
                text-transform: uppercase;
                font-size: 1.6rem;
                color: #999;
                &.selected {
                    color: $color2;
                }
                &.haveChildren:hover {
                    @extend %primary-text;
                    transition: 0.2s;
                }
            }
        }
        @extend %third-text;
        display: none;

        &.active {
            display: block;
            transition: all 0.3s;
        }
        & > div:first-letter {
            text-transform: uppercase;
        }
    }
}
</style>



// WEBPACK FOOTER //
// category-picker.vue?24e77cfe